import { DependencyContainer } from '../../../DependencyContainer';
import { CsvFilePostResponse, CsvFileSummary } from '../../../types';

export default class CsvLocationsFileService {
  constructor(private readonly factory: DependencyContainer) {}

  async getCsvLocationsFileList(partnerId: string): Promise<CsvFileSummary[]> {
    const response = await this.factory.csvLocationsFileClient.getCsvLocationsFileList(
      partnerId,
    );
    return response.data;
  }

  async deleteCsvLocationsFile(
    partnerId: string,
    fileId: string,
  ): Promise<void> {
    await this.factory.csvLocationsFileClient.deleteCsvLocationsFile(
      partnerId,
      fileId,
    );
  }

  async createCsvLocationsFile(
    partnerId: string,
    dto: any,
  ): Promise<CsvFilePostResponse> {
    const response = await this.factory.csvLocationsFileClient.createCsvLocationsFile(
      partnerId,
      dto,
    );
    return response.data;
  }
}
